<div [formGroup]="group">

  <app-formelementinputlabel [config]="config" [group]="group"></app-formelementinputlabel>

  <app-radio [config]="config" [group]="group" [formControlName]="config.name" #formInput></app-radio>

  <app-formelementinputdescription [config]="config" [group]="group"></app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group"></app-formelementinput-validationmessages>
</div>
